import React from 'react';

import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

import { cn } from 'components/lib/utils';

interface SortableItemProps {
    id: string;
    children: React.ReactNode;
}

export const SortableItem: React.FC<SortableItemProps> = ({
    id,
    children
}) => {
    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition,
        isDragging
    } = useSortable({ id });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition
    };

    const childrenWithProps = React.Children.map(children, (child) => {
        if (React.isValidElement(child)) {
            return React.cloneElement(child, {
                dragHandleListeners: listeners,
                dragHandleAttributes: attributes
            } as any);
        }
        return child;
    });

    return (
        <div
            ref={setNodeRef}
            style={style}
            className={cn(
                'cursor-default select-none',
                isDragging ? 'opacity-0' : 'opacity-100'
            )}
        >
            {childrenWithProps}
        </div>
    );
};

export default SortableItem;

